<div class="inset" >
    <h1>{{title | titlecase}}</h1>
    <h4>{{subtitle}}</h4>
    <div class = "horizontalLine"></div>
  </div>